import React from 'react';
import { motion } from 'framer-motion';
interface EnhancedTableProps {
  content: string;
}
export function EnhancedTable({
  content
}: EnhancedTableProps) {
  const rows = content.trim().split('\n').map(row => row.split('|').map(cell => cell.trim()).filter(Boolean));
  if (rows.length < 2) return null;
  const headers = rows[0];
  const dataRows = rows.slice(2); // Skip separator row
  return <motion.div initial={{
    opacity: 0,
    y: 5
  }} animate={{
    opacity: 1,
    y: 0
  }} transition={{
    duration: 0.2
  }} className="overflow-x-auto rounded-lg border border-slate-700" data-id="element-306">
      <table className="min-w-full" data-id="element-307">
        <thead className="bg-slate-800" data-id="element-308">
          <tr data-id="element-309">
            {headers.map((header, index) => <th key={index} className="px-4 py-3 text-left text-xs font-semibold text-slate-300 border-b border-slate-700" data-id="element-310">
                {header}
              </th>)}
          </tr>
        </thead>
        <tbody data-id="element-311">
          {dataRows.map((row, rowIndex) => <tr key={rowIndex} className="border-b border-slate-800 last:border-0 hover:bg-slate-800/30 transition-colors" data-id="element-312">
              {row.map((cell, cellIndex) => <td key={cellIndex} className="px-4 py-3 text-sm text-slate-200" data-id="element-313">
                  {cell}
                </td>)}
            </tr>)}
        </tbody>
      </table>
    </motion.div>;
}